import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDischargeField } from "../../../../Redux/actions/dischargeActions";

const DISPOSITIONS = [
  { id: "DISP001", desc: "Discharged Home" },
  { id: "DISP002", desc: "LAMA (Leave Against Medical Advice)" },
  { id: "DISP003", desc: "Referred" },
  { id: "DISP004", desc: "Transfer to Another Facility" },
];

export default function Disposition() {
  const dispatch = useDispatch();
  const dispositionDesc = useSelector(
    (state) => state.discharge?.dispositionDesc || "Discharged Home"
  );

  const handleSelectDisposition = (disp) => {
    dispatch(setDischargeField("dispositionId", disp.id));
    dispatch(setDischargeField("dispositionDesc", disp.desc));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-3 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        12. Disposition
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4 text-sm text-gray-700">
        {DISPOSITIONS.map((disp) => {
          const isSelected = dispositionDesc === disp.desc;
          return (
            <label
              key={disp.id}
              className="flex items-center gap-2 cursor-pointer hover:text-teal-800 transition"
            >
              <input
                type="radio"
                name="disposition"
                checked={isSelected}
                onChange={() => handleSelectDisposition(disp)}
                className="w-4 h-4 text-teal-600 focus:ring-teal-500"
              />
              <span className={isSelected ? "font-semibold text-teal-800" : ""}>
                {disp.desc}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
